import type { SVGProps } from 'react'

interface WheatIconProps extends SVGProps<SVGSVGElement> {}

export function WheatIcon(props: WheatIconProps) {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.1166 5.57839C27.1166 6.57273 26.5142 7.45009 26.0053 8.01747C25.8006 8.06424 25.6076 8.1286 25.4321 8.21632C25.9878 7.55537 26.5317 6.62539 26.5317 5.57839C26.5317 4.3501 25.783 3.29142 25.1572 2.62462L25.1514 2.61877C25.2508 2.5252 25.3151 2.47839 25.3151 2.47839C25.3151 2.47839 27.1166 3.86462 27.1166 5.57839Z"
        fill="currentColor"
      />
      <path
        d="M29.4733 8.64917C29.4733 8.64917 29.4031 10.5209 28.2509 11.3398C28.0578 11.4743 27.8531 11.5737 27.6367 11.6439C28.8007 10.6145 28.8826 8.75445 28.8884 8.67259C28.8884 8.61994 28.8884 8.57313 28.8767 8.52637C29.2335 8.57899 29.4733 8.64917 29.4733 8.64917Z"
        fill="currentColor"
      />
      <path
        d="M29.4736 12.7669C29.4736 12.7669 29.4034 14.6327 28.2512 15.4516C28.064 15.5861 27.8593 15.6797 27.6487 15.7499C28.801 14.7204 28.8829 12.8722 28.8887 12.7903C28.8887 12.7376 28.8887 12.685 28.877 12.6382C29.2338 12.6967 29.4736 12.7669 29.4736 12.7669Z"
        fill="currentColor"
      />
      <path
        d="M29.4743 16.8788C29.4743 16.8788 29.4041 18.7505 28.2518 19.5694C28.0588 19.7097 27.8482 19.8033 27.6318 19.8794C28.8016 18.8558 28.8835 16.9841 28.8894 16.9022C28.8894 16.8495 28.8894 16.7969 28.8777 16.7501C29.2345 16.8086 29.4743 16.8788 29.4743 16.8788Z"
        fill="currentColor"
      />
      <path
        d="M7.40322 5.57697C7.40322 7.28974 5.60249 8.67822 5.60249 8.67822C5.60249 8.67822 3.80176 7.28974 3.80176 5.57697C3.80176 3.86419 5.60249 2.47571 5.60249 2.47571C5.60249 2.47571 7.40322 3.86419 7.40322 5.57697Z"
        fill="currentColor"
      />
      <path
        d="M4.38456 8.92716C5.53281 9.74622 5.60253 11.6174 5.60253 11.6174C5.60253 11.6174 3.81056 12.1607 2.66231 11.3416C1.51406 10.5225 1.44434 8.65133 1.44434 8.65133C1.44434 8.65133 3.2363 8.1081 4.38456 8.92716Z"
        fill="currentColor"
      />
      <path
        d="M6.82051 8.92716C5.67226 9.74622 5.60254 11.6174 5.60254 11.6174C5.60254 11.6174 7.39451 12.1607 8.54276 11.3416C9.69101 10.5225 9.76073 8.65133 9.76073 8.65133C9.76073 8.65133 7.96877 8.1081 6.82051 8.92716Z"
        fill="currentColor"
      />
      <path
        d="M4.38456 13.0398C5.53281 13.8589 5.60253 15.7301 5.60253 15.7301C5.60253 15.7301 3.81056 16.2733 2.66231 15.4543C1.51406 14.6352 1.44434 12.764 1.44434 12.764C1.44434 12.764 3.2363 12.2208 4.38456 13.0398Z"
        fill="currentColor"
      />
      <path
        d="M6.82051 13.0398C5.67226 13.8589 5.60254 15.7301 5.60254 15.7301C5.60254 15.7301 7.39451 16.2733 8.54276 15.4543C9.69101 14.6352 9.76073 12.764 9.76073 12.764C9.76073 12.764 7.96877 12.2208 6.82051 13.0398Z"
        fill="currentColor"
      />
      <path
        d="M4.38456 17.1524C5.53281 17.9714 5.60253 19.8426 5.60253 19.8426C5.60253 19.8426 3.81056 20.3859 2.66231 19.5668C1.51406 18.7478 1.44434 16.8766 1.44434 16.8766C1.44434 16.8766 3.2363 16.3333 4.38456 17.1524Z"
        fill="currentColor"
      />
      <path
        d="M6.82051 17.1524C5.67226 17.9714 5.60254 19.8426 5.60254 19.8426C5.60254 19.8426 7.39451 20.3859 8.54276 19.5668C9.69101 18.7478 9.76073 16.8766 9.76073 16.8766C9.76073 16.8766 7.96877 16.3333 6.82051 17.1524Z"
        fill="currentColor"
      />
      <path
        d="M5.60276 22.9166C5.44111 22.9166 5.3103 22.7858 5.3103 22.6242V5.83957C5.3103 5.67792 5.44111 5.54712 5.60276 5.54712C5.7644 5.54712 5.89521 5.67792 5.89521 5.83957V22.6242C5.89521 22.7858 5.7644 22.9166 5.60276 22.9166Z"
        fill="currentColor"
      />
      <path
        d="M16.6737 5.57697C16.6737 7.28974 14.873 8.67822 14.873 8.67822C14.873 8.67822 13.0723 7.28974 13.0723 5.57697C13.0723 3.86419 14.873 2.47571 14.873 2.47571C14.873 2.47571 16.6737 3.86419 16.6737 5.57697Z"
        fill="currentColor"
      />
      <path
        d="M13.6551 8.92716C14.8033 9.74622 14.873 11.6174 14.873 11.6174C14.873 11.6174 13.0811 12.1607 11.9328 11.3416C10.7846 10.5225 10.7148 8.65133 10.7148 8.65133C10.7148 8.65133 12.5068 8.1081 13.6551 8.92716Z"
        fill="currentColor"
      />
      <path
        d="M16.091 8.92716C14.9428 9.74622 14.873 11.6174 14.873 11.6174C14.873 11.6174 16.665 12.1607 17.8133 11.3416C18.9615 10.5225 19.0312 8.65133 19.0312 8.65133C19.0312 8.65133 17.2393 8.1081 16.091 8.92716Z"
        fill="currentColor"
      />
      <path
        d="M13.6551 13.0398C14.8033 13.8589 14.873 15.7301 14.873 15.7301C14.873 15.7301 13.0811 16.2733 11.9328 15.4543C10.7846 14.6352 10.7148 12.764 10.7148 12.764C10.7148 12.764 12.5068 12.2208 13.6551 13.0398Z"
        fill="currentColor"
      />
      <path
        d="M16.091 13.0398C14.9428 13.8589 14.873 15.7301 14.873 15.7301C14.873 15.7301 16.665 16.2733 17.8133 15.4543C18.9615 14.6352 19.0312 12.764 19.0312 12.764C19.0312 12.764 17.2393 12.2208 16.091 13.0398Z"
        fill="currentColor"
      />
      <path
        d="M13.6551 17.1524C14.8033 17.9714 14.873 19.8426 14.873 19.8426C14.873 19.8426 13.0811 20.3859 11.9328 19.5668C10.7846 18.7478 10.7148 16.8766 10.7148 16.8766C10.7148 16.8766 12.5068 16.3333 13.6551 17.1524Z"
        fill="currentColor"
      />
      <path
        d="M16.091 17.1524C14.9428 17.9714 14.873 19.8426 14.873 19.8426C14.873 19.8426 16.665 20.3859 17.8133 19.5668C18.9615 18.7478 19.0312 16.8766 19.0312 16.8766C19.0312 16.8766 17.2393 16.3333 16.091 17.1524Z"
        fill="currentColor"
      />
      <path
        d="M14.892 21.9907C14.7303 21.9907 14.5995 21.8599 14.5995 21.6989L14.5801 5.84014C14.5801 5.67849 14.7109 5.54712 14.872 5.54712C15.0336 5.54712 15.165 5.67792 15.165 5.839L15.1844 21.6977C15.1844 21.8594 15.053 21.9907 14.892 21.9907Z"
        fill="currentColor"
      />
      <path
        d="M25.9465 5.57839C25.9465 6.63706 25.2564 7.57294 24.7299 8.13442C24.4082 8.47953 24.145 8.67838 24.145 8.67838C24.145 8.67838 22.3435 7.29216 22.3435 5.57839C22.3435 3.86462 24.145 2.47839 24.145 2.47839C24.145 2.47839 24.4082 2.67728 24.7299 3.02235C25.2564 3.58387 25.9465 4.51971 25.9465 5.57839Z"
        fill="currentColor"
      />
      <path
        d="M22.9253 8.92716C24.0736 9.74622 24.1433 11.6174 24.1433 11.6174C24.1433 11.6174 22.3513 12.1607 21.2031 11.3416C20.0548 10.5225 19.9851 8.65133 19.9851 8.65133C19.9851 8.65133 21.7771 8.1081 22.9253 8.92716Z"
        fill="currentColor"
      />
      <path
        d="M28.3037 8.6491C28.3037 8.6491 28.2335 10.5208 27.0813 11.3397C26.7537 11.5736 26.3735 11.6965 25.9933 11.7491C25.9933 11.7491 25.9933 11.7491 25.9875 11.7491C25.0516 11.8895 24.145 11.6146 24.145 11.6146C24.145 11.6146 24.2152 9.74872 25.3616 8.92988C26.0577 8.43268 26.9994 8.43854 27.6311 8.51458H27.6369C28.0347 8.56724 28.3037 8.6491 28.3037 8.6491Z"
        fill="currentColor"
      />
      <path
        d="M22.9253 13.0398C24.0736 13.8589 24.1433 15.7301 24.1433 15.7301C24.1433 15.7301 22.3513 16.2733 21.2031 15.4543C20.0548 14.6352 19.9851 12.764 19.9851 12.764C19.9851 12.764 21.7771 12.2208 22.9253 13.0398Z"
        fill="currentColor"
      />
      <path
        d="M28.3037 12.7669C28.3037 12.7669 28.2335 14.6327 27.0813 15.4516C26.7479 15.6856 26.3677 15.8084 25.9875 15.8669H25.9816C25.0458 16.0014 24.145 15.7324 24.145 15.7324C24.145 15.7324 24.2152 13.8607 25.3616 13.0418C26.0577 12.5446 26.9935 12.5505 27.6252 12.6323H27.6311C28.0288 12.685 28.3037 12.7669 28.3037 12.7669Z"
        fill="currentColor"
      />
      <path
        d="M22.9253 17.1524C24.0736 17.9714 24.1433 19.8426 24.1433 19.8426C24.1433 19.8426 22.3513 20.3859 21.2031 19.5668C20.0548 18.7478 19.9851 16.8766 19.9851 16.8766C19.9851 16.8766 21.7771 16.3333 22.9253 17.1524Z"
        fill="currentColor"
      />
      <path
        d="M28.3037 16.8787C28.3037 16.8787 28.2335 18.7504 27.0813 19.5693C26.7537 19.8032 26.3735 19.9261 25.9933 19.9787C25.9933 19.9787 25.9933 19.9787 25.9875 19.9787C25.0516 20.1191 24.145 19.8442 24.145 19.8442C24.145 19.8442 24.2152 17.9725 25.3616 17.1536C26.0577 16.6564 26.9935 16.6623 27.6252 16.7442H27.6311C28.0288 16.7968 28.3037 16.8787 28.3037 16.8787Z"
        fill="currentColor"
      />
      <path
        d="M24.1428 23.2411C23.9811 23.2411 23.8503 23.1103 23.8503 22.9486V5.83957C23.8503 5.67792 23.9811 5.54712 24.1428 5.54712C24.3044 5.54712 24.4352 5.67792 24.4352 5.83957V22.9486C24.4352 23.1103 24.3044 23.2411 24.1428 23.2411Z"
        fill="currentColor"
      />
      <path
        d="M29.5559 26.7052V27.5065C29.5559 28.068 29.0997 28.5242 28.5382 28.5242H28.0235C28.2458 28.2493 28.3861 27.8925 28.3861 27.5065V26.7052C28.3861 26.0676 28.0176 25.5178 27.4737 25.2663C27.2514 24.2953 26.6606 23.4648 25.8418 22.9442C27.3392 23.0612 28.5206 24.2193 28.7137 25.6933H28.5441C29.0997 25.6933 29.5559 26.1437 29.5559 26.7052Z"
        fill="currentColor"
      />
      <path
        d="M26.8239 25.1084H2.95977C2.92468 25.1084 2.88959 25.1084 2.85449 25.1142C3.15862 23.6871 4.42203 22.605 5.94278 22.605C7.01316 22.605 7.96071 23.1372 8.53976 23.9503C9.09543 23.4589 9.82656 23.1606 10.6337 23.1606C11.1367 23.1606 11.6105 23.2718 12.0258 23.4882C12.5463 22.4236 13.6343 21.6984 14.8918 21.6984C16.2488 21.6984 17.4128 22.5582 17.8573 23.7631C18.2492 23.5876 18.682 23.4882 19.1441 23.4882C19.9396 23.4882 20.6765 23.7865 21.2322 24.2778C21.8113 23.4648 22.753 22.9325 23.8292 22.9325C24.1333 22.9325 24.4316 22.9735 24.7066 23.0612C25.7067 23.3478 26.4964 24.1199 26.8239 25.1084Z"
        fill="currentColor"
      />
      <path
        d="M27.8011 26.7052V27.5066C27.8011 28.0681 27.3449 28.5243 26.7833 28.5243H2.96015C2.39863 28.5243 1.94824 28.0739 1.94824 27.5124V26.7052C1.94824 26.1437 2.39863 25.6934 2.96015 25.6934H26.7892C27.3449 25.6934 27.8011 26.1437 27.8011 26.7052Z"
        fill="currentColor"
      />
    </svg>
  )
}
